import { ContactUsTemplate, MainLayout } from "@/design-system/Templates";
import Header from "@/design-system/Organisms/Header";
import { headerConfig } from "@/design-system/Organisms/Header/Header.config";
import { Footer, ContactUsHeroBanner } from "@/design-system/Organisms";
import { contactUsHeroData } from "@/design-system/Organisms/HeroBanner/heroBanner.data";
import { useScrollToTopOnMount } from "@/hooks/useScrollToTopOnMount";

const ContactUsPage = () => {
    useScrollToTopOnMount();
    return (
        <MainLayout
            header={<Header {...headerConfig} />}
            sidebar={null}
            className=""
            footer={<Footer />}
            topBanner={<ContactUsHeroBanner {...contactUsHeroData} />}
        >
            <ContactUsTemplate />
        </MainLayout>
    );
};

export default ContactUsPage;
